export const CAMPAIGN_CREATE = 'CAMPAIGN_CREATE'
export const CAMPAIGN_DETAIL = 'CAMPAIGN_DETAIL'
export const ACTION_ID = 'ACTION_ID'
export const CAMPAIGN_RESET = 'RESET_CREATE_CAMPAIGN';
